import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { ProductPreview } from "../../../domain/projections/ProductPreview";
import { ProductRepositoryImpl } from "../../domain/productRepositoryImpl/ProductRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";

const productRepo = ProductRepositoryImpl.getInstance();

const useGetSimilarProducts = (variantId: string) => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const { isLoading, data } = useQuery(
    {
      queryKey: ["useGetSimilarProducts", auth, variantId],
      queryFn: async () => {
        return await productRepo.getSimilarProducts(auth, variantId, apiUrl);
      },
      enabled: Boolean(auth) && Boolean(variantId),
    },
    queryClient,
  );

  return { isLoading, products: data || ([] as ProductPreview[]) };
};

export { useGetSimilarProducts };
